import React from 'react'
import './Page404.css'
const Page404 = () => {
  return (
    <>
      <div className='login_body'>
        <div id='stars'></div>
        <div id='stars2'></div>
        <div id='stars3'></div>
        <div className='body_404'>
          <img className='Img404' src='./Page404.svg' alt='404' />
        </div>
      </div>
    </>
  )
}

export default Page404